var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDeleteCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99984 0.666672C12.0499 0.666672 15.3332 3.94992 15.3332 8C15.3332 12.0501 12.0499 15.3333 7.99984 15.3333C3.94975 15.3333 0.666504 12.0501 0.666504 8C0.666504 3.94992 3.94975 0.666672 7.99984 0.666672ZM8.00067 1.6326C4.48451 1.6326 1.6341 4.48301 1.6341 7.99917C1.6341 11.5153 4.48451 14.3657 8.00067 14.3657C11.5168 14.3657 14.3672 11.5153 14.3672 7.99917C14.3672 4.48301 11.5168 1.6326 8.00067 1.6326ZM9.90779 5.46351C10.0814 5.28995 10.3628 5.28995 10.5363 5.46351C10.7099 5.63708 10.7099 5.91849 10.5363 6.09205L8.6285 8L10.5363 9.90796C10.6925 10.0642 10.7082 10.3077 10.5832 10.4814L10.5363 10.5365C10.3628 10.7101 10.0814 10.7101 9.90779 10.5365L7.99984 8.62867L6.09188 10.5365C5.93567 10.6927 5.69211 10.7083 5.51843 10.5834L5.46335 10.5365C5.28978 10.3629 5.28978 10.0815 5.46335 9.90796L7.37117 8L5.46335 6.09205C5.30714 5.93584 5.29151 5.69228 5.41648 5.5186L5.46335 5.46351C5.63691 5.28995 5.91832 5.28995 6.09188 5.46351L7.99984 7.37134L9.90779 5.46351Z",
    fill: "#696969"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDeleteCross);
export default __webpack_public_path__ + "static/media/icon-delete-cross.743009afbfd7f2cadf7b5433ec4a734c.svg";
export { ForwardRef as ReactComponent };